import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { Observable } from 'rxjs';
import { BROWSER_TAB_HEADER, browserTabId, sendsTabHeader } from './BrowserTabHelper';

/**
 * Adds this tab's id to every request to the app's own API (see BrowserTabHelper). Provided by every module that
 * imports HttpClientModule under the signed-in app (AppModule, SettingsModule), because each of those gets its own
 * HttpClient and interceptor list.
 */
@Injectable()
export class BrowserTabHeaderInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!sendsTabHeader(req.url, AppConsts.remoteServiceBaseUrl)) {
            return next.handle(req);
        }
        return next.handle(req.clone({ setHeaders: { [BROWSER_TAB_HEADER]: browserTabId } }));
    }
}
